/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./bootstrap/echo');
require('./bootstrap/laroute');
require('./bootstrap/sentry');
require('./bootstrap/vuex');
require('./bootstrap/ziggy');

require('eonasdan-bootstrap-datetimepicker');
require('./components');

require('./franchise_component/common');
require('./franchise_component/customer');
require('./franchise_component/dashboard');
require('./franchise_component/dashboard/operational-dashboard');
require('./franchise_component/inventory/fuel');
require('./franchise_component/inventory/override_pricebook');
require('./franchise_component/inventory/pricebook');
require('./franchise_component/inventory/tank');
require('./franchise_component/loyalty');
require('./franchise_component/report/promotion');
require('./franchise_component/report/pwp-promotion');
require('./franchise_component/report/budi-summary');
require('./franchise_component/royalty');
require('./franchise_component/profile');
require('./franchise_component/subscription');
require('./franchise_component/promotion');
require('./franchise_component/report/daily-sales');
require('./franchise_component/report/daily-sales-legacy');
require('./franchise_component/report/reimbursement');
require('./franchise_component/report/cdb-reimbursement');
require('./franchise_component/report/drawersession');
require('./franchise_component/report/fuel');
require('./franchise_component/report/summary-flowrate');
require('./franchise_component/report/cancelled-order');
require('./franchise_component/report/new-cancelled-order');
require('./franchise_component/report/sales-category');
require('./franchise_component/report/subsidy');
require('./franchise_component/report/clawback');
require('./franchise_component/report/sales-movement');
require('./franchise_component/report/loyalty-category');
require('./franchise_component/role');
require('./franchise_component/setting/outlet-central-settings');
require('./franchise_component/setting/hub-settings');
require('./franchise_component/staff');
require('./franchise_component/staff/role');
require('./franchise_component/pdb-landing-page');
require('./franchise_component/user');
require('./franchise_component/franchise-inventory/sync');
require('./franchise_component/franchise-inventory/dashboard');
require('./franchise_component/franchise-inventory/stock');
require('./franchise_component/franchise-inventory/stock-fifo');
require('./franchise_component/franchise-inventory/stock-cost');
require('./franchise_component/franchise-inventory/audit-trail');
require('./franchise_component/franchise-inventory/supplier');
require('./franchise_component/franchise-inventory/stock-check');
require('./franchise_component/franchise-inventory/stock-receive');
require('./franchise_component/franchise-inventory/stock-return');
require('./franchise_component/franchise-inventory/monitor');
require('./franchise_component/audit-trail');
require('./franchise_component/report/drawer-check');
require('./franchise_component/report/pump-test');
require('./franchise_component/report/price-override');
require('./franchise_component/report/totalizer-transaction');
require('./franchise_component/franchise-inventory/cost-good-sold');
require('./franchise_component/report/profit');
require('./franchise_component/melissa-feedback');

require('./plugins/parsleyjs');
require('./plugins/vuetable');
require('./plugins/toastr');

import Vue from 'vue';
import VuePapaParse from 'vue-papa-parse';
import ECharts from 'vue-echarts';
import store from './store';
import Multiselect from 'vue-multiselect';
import VeeValidate from 'vee-validate';
import InfiniteLoading from 'vue-infinite-loading';
import { VueEditor } from 'vue2-editor';
import VueClipboard from 'vue-clipboard2';
import VueTheMask from 'vue-the-mask';
import VueTable2Checkbox from './plugins/vuetable2-checkbox';
import { Pagination } from 'vue-pagination-2';

import mixins from './mixins';
import LangMixin from './mixins/lang';
import LaravelErrorMixin from './mixins/validator-laravel-error';
import LoadingMixin from './mixins/loading';
import swalMixin from './mixins/swal';
import SubscriptionMixin from './mixins/subscription';
import Swatches from 'vue-swatches';
import draggable from 'vuedraggable';
import VueTimeago from 'vue-timeago';
import VTooltip from 'v-tooltip';
import parsleyMixin from './mixins/parsley';
import Inview from 'vueinview';

/* vue-echarts v4 removed echarts dependencies so need to install and import manually */
import 'echarts';
import 'echarts-liquidfill';

let inProduction = process.env.NODE_ENV === 'production';

Vue.config.debug = !inProduction;
Vue.config.devtools = !inProduction;

Vue.prototype.$http = window.axios;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the body of the page. From here, you may begin adding components to
 * the application, or feel free to tweak this setup for your needs.
 */

/** Form Validation for vue js **/
Vue.use(VeeValidate);
Vue.use(VueTable2Checkbox);
Vue.use(VuePapaParse);
Vue.use(VTooltip);
Vue.mixin(mixins);
Vue.mixin(LangMixin);
Vue.mixin(LaravelErrorMixin);
Vue.mixin(LoadingMixin);
Vue.mixin(SubscriptionMixin);
Vue.mixin(swalMixin);
Vue.mixin(parsleyMixin);

Vue.use(VueTheMask);
Vue.use(VueClipboard);
Vue.use(VueTimeago, { locale: 'en' });
Vue.use(Inview);

// set autohide when click outside of popover to false
VTooltip.options.popover.defaultAutoHide = false;

Vue.component('vue-draggable', draggable);
Vue.component('chart', ECharts);
Vue.component('datepicker', require('./components/Datepicker.vue'));
Vue.component('monthpicker', require('./components/Monthpicker.vue'));
Vue.component(
    'monthpickersalesmovement',
    require('./components/MonthpickerSalesMovement.vue'),
);
Vue.component('aside-modal', require('./components/AsideModal.vue'));
Vue.component('modal', require('./components/modal.vue'));
Vue.component('bottom-modal', require('./components/BottomModal.vue'));
Vue.component('calendar', require('./components/Calendar.vue'));
Vue.component('vue-swatches', Swatches);

/** Vue WYSIWYG Editor */
Vue.component('vue-editor', VueEditor);

Vue.component('pagination', Pagination);

/** Vue Select 2 **/
Vue.component('multiselect', Multiselect);
Vue.component('infinite-loading', InfiniteLoading);

/** Franchise Global Vue Element */
Vue.component('loading-spinner', require('./components/LoadingSpinner.vue'));
Vue.component('outlet-selector', require('./components/OutletSelector.vue'));
Vue.component('till-selector', require('./components/TillSelector.vue'));
Vue.component(
    'product-selector',
    require('./components/selector/product-selector.vue'),
);
Vue.component(
    'custom-filter',
    require('./components/filter/custom-filter.vue'),
);
Vue.component(
    'multi-outlet-selector',
    require('./components/selector/multi-outlet-selector.vue'),
);
Vue.component(
    'tax-selector',
    require('./components/selector/tax-selector.vue'),
);
Vue.component(
    'stock-selector',
    require('./components/selector/stock-selector.vue'),
);
Vue.component(
    'supplier-selector',
    require('./components/selector/supplier-selector.vue'),
);
Vue.component(
    'stock-receive-selector',
    require('./components/selector/stock-receive-selector.vue'),
);
Vue.component('dropzone', require('./components/vue_dropzone.vue'));
Vue.component(
    'vue-dropzone-popup',
    require('./components/VueDropzonePopup.vue'),
);
Vue.component('time-picker', require('./components/timepicker.vue'));
Vue.component(
    'vue-google-autocomplete',
    require('./components/VueGoogleAutocomplete.vue'),
);

/** Franchise Subscription Renewal Vue Element*/
Vue.component(
    'almost-expiry-announcement',
    require('./franchise_component/subscription-renewal/almost-expiry-announcement.vue'),
);

/** Franchise Dashboard Vue Element*/
Vue.component(
    'dashboard',
    require('./franchise_component/dashboard/dashboard.vue'),
);
Vue.component(
    'dashboard-report',
    require('./franchise_component/dashboard/dashboard-report.vue'),
);
Vue.component(
    'dashboard-target-sales',
    require('./franchise_component/dashboard/dashboard-target-sales.vue'),
);

Vue.component(
    'staff-profile',
    require('./franchise_component/outlet/staff/staff_profile.vue'),
);

/** Franchise Snapshot Vue Element*/
Vue.component('metric-summary', require('./components/MetricSummary.vue'));
Vue.component(
    'vuetable_snapshot',
    require('./franchise_component/snapshot/vuetable_snapshot.vue'),
);
Vue.component(
    'vue_snapshot',
    require('./franchise_component/snapshot/vue_snapshot.vue'),
);

/** Franchise Item report*/
Vue.component(
    'item-box-chart',
    require('./franchise_component/item/boxChart.vue'),
);
Vue.component(
    'vuetable-tag-sales',
    require('./franchise_component/item/vuetable_tag_sales.vue'),
);
Vue.component(
    'vuetable-category-sales',
    require('./franchise_component/item/vuetable-category-sales.vue'),
);
Vue.component(
    'vuetable-staff-sales',
    require('./franchise_component/item/vuetable-staff-sales.vue'),
);
Vue.component(
    'variant-sales-report',
    require('./franchise_component/item/variant-sales-report.vue'),
);

/** Franchise Transaction Vue Element*/
Vue.component(
    'transactionTypeSummary',
    require('./franchise_component/transaction/sumTransactionType.vue'),
);
Vue.component(
    'transactionChart',
    require('./franchise_component/transaction/chart.vue'),
);
Vue.component(
    'transaction-breakdown',
    require('./franchise_component/transaction/transaction-breakdown.vue'),
);
Vue.component(
    'transaction-breakdown-details',
    require('./franchise_component/transaction/transaction-breakdown-details.vue'),
);
Vue.component(
    'vuetable_transaction',
    require('./franchise_component/transaction/vuetable_transaction.vue'),
);
Vue.component(
    'vuepopup_receipt',
    require('./franchise_component/transaction/side_receipt.vue'),
);
Vue.component('receipt', require('./franchise_component/receipt/receipt.vue'));

/** Franchise ES Transaction Vue Element*/
Vue.component(
    'transaction-breakdown-es',
    require('./franchise_component/transaction/es-report/transaction-breakdown-es.vue'),
);
Vue.component(
    'vuetable-transaction-es',
    require('./franchise_component/transaction/es-report/vuetable-transaction-es.vue'),
);

/** Franchise Voided Vue Element*/
Vue.component(
    'vuetable_voided',
    require('./franchise_component/voided/vuetable_voided.vue'),
);
Vue.component(
    'vuetable_aborted',
    require('./franchise_component/voided/vuetable_aborted.vue'),
);
Vue.component(
    'voided-sales-summary',
    require('./franchise_component/voided/boxSummary.vue'),
);
Vue.component(
    'voided-orders',
    require('./franchise_component/voided/voided-orders.vue'),
);

/** Franchise ES Voided Vue Element*/
Vue.component(
    'voided-receipt-datatable-es',
    require('./franchise_component/voided/es-report/voided-receipt-datatable'),
);
Vue.component(
    'returned-items-datatable-es',
    require('./franchise_component/voided/es-report/returned-item-datatable'),
);
Vue.component(
    'voided-sales-summary-es',
    require('./franchise_component/voided/es-report/summary'),
);

/** Franchise Tax Vue Element*/
Vue.component(
    'vuetable_tax',
    require('./franchise_component/tax/vuetable_tax.vue'),
);

/** Franchise Modifier report Vue Element*/
Vue.component(
    'vuetable-modifier-report',
    require('./franchise_component/modifier/index.vue'),
);

/** Franchise Discount Vue Element*/
Vue.component(
    'vuetable-discount-report',
    require('./franchise_component/discount/index.vue'),
);

/** Franchise Tax Vue Element*/
Vue.component(
    'vuetable-discount',
    require('./franchise_component/setting/discount/datatable.vue'),
);

/** Franchise Payment Vue Element*/
Vue.component(
    'settings-payment-index',
    require('./franchise_component/setting/payment/settings-payment-index.vue'),
);

/* Setting main page */
Vue.component(
    'franchise-settings',
    require('./franchise_component/setting/settings.vue'),
);

/* Email Notification Components */
Vue.component(
    'email-notification',
    require('./franchise_component/setting/email-notification/email-notification.vue'),
);
Vue.component(
    'email-form',
    require('./franchise_component/setting/email-notification/email-notification-form.vue'),
);

/** Franchise Inventory Tag Vue Element*/
Vue.component(
    'vuetable_tag',
    require('./franchise_component/inventory/tag/vuetable_tag.vue'),
);
Vue.component(
    'vuetabletag_form',
    require('./franchise_component/inventory/tag/vuetabletag_form.vue'),
);

/** Franchise Inventory Planogram Vue Element*/
Vue.component(
    'planogram_table',
    require('./franchise_component/inventory/planogram/planogram_table.vue'),
);

/** Franchise FAQ & Guidelines Vue Element*/
Vue.component(
    'faq_guideline_index',
    require('./franchise_component/faq_guideline/faq-guideline-index.vue'),
);

Vue.component(
    'faq_guideline_portal',
    require('./franchise_component/faq_guideline/faq-guideline-portal.vue'),
);

Vue.component(
    'faq_guideline_view_all',
    require('./franchise_component/faq_guideline/faq-guideline-view-all.vue'),
);

Vue.component(
    'product_list',
    require('./franchise_component/inventory/tag/product_list.vue'),
);

Vue.component(
    'station_list',
    require('./franchise_component/promotion/station_list.vue'),
);

/** Franchise Inventory Modifier Vue Element*/
Vue.component(
    'vuetable_modifier',
    require('./franchise_component/inventory/modifier/vuetable_modifier.vue'),
);
Vue.component(
    'vuetablemodifier_form',
    require('./franchise_component/inventory/modifier/vuetablemodifier_form.vue'),
);

/** Franchise Inventory items Vue Element*/
Vue.component(
    'vuetable_item',
    require('./franchise_component/inventory/item/vuetable_item.vue'),
);
Vue.component(
    'vuetableitem_form',
    require('./franchise_component/inventory/item/vuetableitem_form.vue'),
);
Vue.component(
    'color_picker',
    require('./franchise_component/inventory/item/colorPicker.vue'),
);

Vue.component(
    'category-list',
    require('./franchise_component/inventory/category/category-list.vue'),
);

Vue.component(
    'region-list',
    require('./franchise_component/region/region-list.vue'),
);

Vue.component(
    'trading-area-list',
    require('./franchise_component/trading-area/trading-area-list.vue'),
);

Vue.component('zone-list', require('./franchise_component/zone/zone-list.vue'));

/** Franchise Inventory coupons Vue Element*/
Vue.component(
    'coupon-master',
    require('./franchise_component/inventory/coupon/coupon-master.vue'),
);
Vue.component(
    'vuetable_coupon',
    require('./franchise_component/inventory/coupon/vuetable_coupon.vue'),
);
Vue.component(
    'vuetablecoupon_form',
    require('./franchise_component/inventory/coupon/vuetablecoupon_form.vue'),
);

/** Franchise Inventory Taxes Vue Element*/
Vue.component(
    'vuetable-tax',
    require('./franchise_component/inventory/tax/vuetable_tax.vue'),
);
Vue.component(
    'vuetable-charge',
    require('./franchise_component/inventory/charge/vuetable_charge.vue'),
);

/** Franchise Settings Preset Reason Vue Element*/
Vue.component(
    'preset-reason-datatable',
    require('./franchise_component/setting/presetreason/presetReasonDatatable.vue'),
);

Vue.component(
    'staff-attendance',
    require('./franchise_component/report/staff-attendance/staff-attendance-list.vue'),
);

// Cash adjustment report
Vue.component(
    'cash-adjustment-report',
    require('./franchise_component/report/cash-adjustment/cash-adjustment.vue'),
);

// Subsidy recovery report
Vue.component(
    'subsidy-recovery-report',
    require('./franchise_component/report/subsidy-recovery/subsidy-recovery.vue'),
);

// Cash Flow Till Closure
Vue.component(
    'cash-flow-report',
    require('./franchise_component/report/daily-sales/cash-flow-report.vue'),
);

// Order Layout
Vue.component(
    'order-layout',
    require('./franchise_component/order-layout/order-layout.vue'),
);

Vue.component(
    'order-layout-list',
    require('./franchise_component/order-layout/order-layout-list.vue'),
);

Vue.component(
    'es-table-pagination',
    require('./components/es-table-pagination.vue'),
);

Vue.component('till-filter', require('./components/till-filter/till-filter'));

Vue.component(
    'subscription-stats',
    require('./franchise_component/subscription/subscription-stats.vue'),
);

Vue.directive('focus', {
    inserted: function(el) {
        el.setAttribute('autofocus', true);
        el.focus();
    },
});

const options = {
    el: '#app',
    store,
};

// load vue routes if global vueRoutes variable exists
if (window.vueRoutes !== undefined) {
    options['router'] = require('./router/')(window.vueRoutes);
}

const app = new Vue(options);



// WEBPACK FOOTER //
// ./resources/assets/js/app.js